import { Scalars, Weld } from '@bechtel/types';

export interface WeldsProps {
  weldList: Weld[];
  selectedWeldIds: string[];
  setSelectedWeldIds: (ids: string[]) => void;
  setSelectedWeld: (weld: Weld) => void;
  selectedWeld: Weld | undefined;
  isFitupRequired: boolean;
}

export interface WeldItemStyledProps {
  isActive: Scalars['Boolean'];
}

export enum MilestoneName {
  Install = 'Install',
  Fitup = 'Fitup',
}
